import { Box } from '@chakra-ui/react';
import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const fontSizeOptions = [
  '8px',
  '12px',
  '14px',
  '16px',
  '20px',
  '24px',
  '32px'
];

// Define size values map
const Size = ReactQuill.Quill.import('attributors/class/size');
Size.whitelist = fontSizeOptions;
ReactQuill.Quill.register(Size, true);

const RichTextEditor = ({ value, onChange }) => {
  const modules = {
    toolbar: {
      container: [
        [{ 'font': [] }],
        [{ 'size': fontSizeOptions }],
        ['bold', 'italic', 'underline'],
        [{ 'list': 'bullet' }],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'align': [] }],
      ],
    },
    clipboard: {
      matchVisual: false,
    },
  };

  const formats = [
    'font', 'size',
    'bold', 'italic', 'underline',
    'list', 'bullet',
    'color', 'background',
    'align'
  ];

//   // Function to clean unwanted tags like <p> and <br>
//   const cleanContent = (content) => {
//     let cleanedContent = content;

//     // Replace <p> tags with a non-breaking div tag for space/line-break compatibility
//     cleanedContent = cleanedContent.replace(/<\/?p>/g, '<div>');

//     // Replace <br> tags with a newline character
//     cleanedContent = cleanedContent.replace(/<br\s*\/?>/g, '\n');

//     return cleanedContent;
//   };

//   const handleChange = (content) => {
//     // Clean the content to remove <p> and <br> tags
//     const cleanedContent = cleanContent(content);
//     onChange(cleanedContent);  // Update the parent state with cleaned content
//   };

  return (
    <Box pos='relative' zIndex='9999'>
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        style={{ height: 'auto' }}
      />
    </Box>
  );
};

export default RichTextEditor;
